// UnauthenticatedRoutes.js - Komponente für nicht authentifizierte Routen
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import PasswordResetForm from '../pages/PasswordResetForm';

/**
 * Komponente zur Verwaltung der nicht authentifizierten Routen
 * 
 * @param {Object} props - Komponenteneigenschaften
 * @param {Function} props.setLoggedIn - Funktion zum Setzen des Login-Status
 */
const UnauthenticatedRoutes = ({ setLoggedIn }) => {
  return (
    <Routes>
      <Route path="/login" element={<Login setLoggedIn={setLoggedIn} />} />
      <Route path="/forgotPassword" element={<PasswordResetForm />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default UnauthenticatedRoutes;
